import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { articlesAPI } from '../services/api';

function Projects() {
  const [articles, setArticles] = useState([]);
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    programId: 'all',
    search: ''
  });

  const fallbackArticles = [
    {
      id: 1,
      program_id: 'international-mobility',
      title: 'Erasmus+ Intercultural Youth Exchange in Siedlce, Poland',
      excerpt: 'A detailed look at the 2024 youth exchange connecting 30 young leaders to discuss environmental issues and sustainability.',
      author: 'Thomas Novak',
      image_url: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80',
      published_at: '2024-05-15 10:00:00'
    },
    {
      id: 2,
      program_id: 'international-mobility',
      title: 'European Solidarity Corps: Volunteering Journey',
      excerpt: 'Discover how ESC volunteers from across Europe are contributing to local communities in Siedlce and Krakow.',
      author: 'Sofia Rodriguez',
      image_url: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=800&q=80',
      published_at: '2024-04-10 14:30:00'
    },
    {
      id: 3,
      program_id: 'global-citizenship',
      title: 'Raising Awareness for Human Rights and Peace',
      excerpt: 'Our digital campaign reaches thousands, advocating for human dignity, self-determination, and the rule of law.',
      author: 'Anna Kowalski',
      image_url: 'https://images.unsplash.com/photo-1469571486090-7d99c11d50c7?auto=format&fit=crop&w=800&q=80',
      published_at: '2024-03-20 09:00:00'
    },
    {
      id: 4,
      program_id: 'cooperation-development',
      title: 'Supporting Educational Infrastructure in Kenya',
      excerpt: 'Collaborating with local schools in rural Kenya to build clean water access and provide learning supplies.',
      author: 'Dr. Michael Chen',
      image_url: 'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=800&q=80',
      published_at: '2024-02-15 11:15:00'
    },
    {
      id: 5,
      program_id: 'youth-empowerment',
      title: 'Youth Leadership Summit 2024: Designing Tomorrow',
      excerpt: 'Building leadership, non-formal education, and active citizenship skills in Krakow for European youth leaders.',
      author: 'Dr. Michael Chen',
      image_url: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=800&q=80',
      published_at: '2024-01-25 16:00:00'
    }
  ];

  useEffect(() => {
    fetchArticles();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [filters, articles]);

  const fetchArticles = async () => {
    try {
      setLoading(true);
      const response = await articlesAPI.getAll();
      if (response.data && response.data.success) {
        setArticles(response.data.data);
      } else {
        setArticles(fallbackArticles);
      }
    } catch (error) {
      console.warn('API error, using local fallback data:', error);
      setArticles(fallbackArticles);
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {
    let filtered = [...articles];
    
    if (filters.programId !== 'all') {
      filtered = filtered.filter(a => a.program_id === filters.programId);
    }
    if (filters.search) {
      filtered = filtered.filter(a => 
        a.title.toLowerCase().includes(filters.search.toLowerCase()) ||
        a.excerpt.toLowerCase().includes(filters.search.toLowerCase())
      );
    }
    
    setFilteredArticles(filtered);
  };

  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value
    });
  };

  const getProgramTitle = (program_id) => {
    const titles = {
      'international-mobility': 'International Mobility Programs',
      'global-citizenship': 'Promotion of Global Citizenship',
      'cooperation-development': 'International Cooperation & Development',
      'youth-empowerment': 'Youth Empowerment & Capacity Building'
    };
    return titles[program_id] || program_id;
  };

  if (loading) {
    return (
      <main>
        <div className="slider-area2">
          <div className="slider-height2 d-flex align-items-center">
            <div className="container">
              <div className="row">
                <div className="col-xl-12">
                  <div className="hero-cap hero-cap2 pt-20 text-center">
                    <h2>Loading Publications...</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main>
      {/* Hero Start */}
      <div className="slider-area2">
        <div className="slider-height2 d-flex align-items-center">
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="hero-cap hero-cap2 pt-20 text-center">
                  <h2>Our Activities & Actions</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Filter Section */}
      <div className="service-area efis-list-filter-area">
        <div className="container">
          <div className="premium-search-container">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-12 mb-3 mb-lg-0">
                <input 
                  type="text" 
                  name="search"
                  className="premium-search-input" 
                  placeholder="Search articles & publications..."
                  value={filters.search}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="col-lg-6 col-md-12">
                <select 
                  name="programId" 
                  className="premium-select-filter" 
                  value={filters.programId} 
                  onChange={handleFilterChange}
                >
                  <option value="all">All Programs</option>
                  <option value="international-mobility">International Mobility Programs</option>
                  <option value="global-citizenship">Promotion of Global Citizenship</option>
                  <option value="cooperation-development">International Cooperation & Development</option>
                  <option value="youth-empowerment">Youth Empowerment & Capacity Building</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Publications Grid */}
      <div className="our-cases-area efis-list-grid-area">
        <div className="container">
          <div className="row">
            {filteredArticles.length === 0 ? (
              <div className="col-12 text-center" style={{ padding: '60px 0' }}>
                <span style={{ fontSize: '50px' }}>📂</span>
                <h3 style={{ marginTop: '20px', color: '#64748b' }}>No publications found.</h3>
              </div>
            ) : (
              filteredArticles.map((article) => (
                <div key={article.id} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                  <div className="single-cases" style={{ boxShadow: '0 10px 30px rgba(0,0,0,0.03)', borderRadius: '12px', overflow: 'hidden', border: '1px solid #e2e8f0', background: '#fff', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <div className="cases-img" style={{ height: '220px', overflow: 'hidden' }}>
                      <img 
                        src={article.image_url || "/assets/img/gallery/case1.png"} 
                        alt={article.title} 
                        style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s' }}
                        onMouseEnter={(e) => e.target.style.transform = 'scale(1.06)'}
                        onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                      />
                    </div>
                    <div className="cases-caption p-4" style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                      <div>
                        <span style={{ fontSize: '12px', color: 'var(--accent-red)', fontWeight: 'bold', display: 'block', marginBottom: '8px', textTransform: 'uppercase' }}>
                          {getProgramTitle(article.program_id)}
                        </span>
                        <h3 style={{ fontSize: '18px', fontWeight: '700', lineHeight: '1.4', marginBottom: '10px' }}>
                          <Link to={`/articles/${article.id}`} style={{ color: '#1e293b' }}>{article.title}</Link>
                        </h3>
                        <p style={{ fontSize: '14px', color: '#64748b', lineHeight: '1.6', height: '70px', overflow: 'hidden', marginBottom: '20px' }}>
                          {article.excerpt}
                        </p>
                      </div>
                      <div>
                        <Link to={`/articles/${article.id}`} className="btn w-100" style={{ textAlign: 'center', padding: '10px 20px', fontSize: '14px' }}>Read Article →</Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </main>
  );
}

export default Projects;